import { useMemo } from 'react';
import PropTypes from 'prop-types';
import LayoutPreview from './LayoutPreview';
import webglAvailable from './vehicleDiagram/scene3d/webglAvailable';
import { positionCode } from './vehicleModels/domain/layout';
import { previewCoverageOf } from './vehicleModels/domain/coveragePreview';
import { findPresetForRenderIdentity } from './vehicleModels/presets/registry';
import { VehicleScene } from './vehicleModels/scene/VehicleScene';

const previewVehicleOf = (preset) => ({
  layout: preset.layout,
  tyres: Object.fromEntries(preset.wheels.map((wheel) => [
    positionCode(wheel.ref),
    { preview: true },
  ])),
});

const SetupRenderPreview = ({ layout }) => {
  const coverage = useMemo(
    () => previewCoverageOf(layout, findPresetForRenderIdentity),
    [layout],
  );
  const canShow3d = coverage.state === 'exact_3d' && webglAvailable();
  const vehicle = useMemo(
    () => (coverage.preset ? previewVehicleOf(coverage.preset) : null),
    [coverage.preset],
  );

  if (!canShow3d) {
    return <div>
      <LayoutPreview layout={layout} />
      <p className="mt-3 text-xs leading-5 text-slate-500">
        {coverage.state === 'exact_3d'
          ? 'This browser is showing the exact 2D position map because WebGL is unavailable.'
          : 'This layout uses the exact 2D position map until a matching 3D preset is published.'}
      </p>
    </div>;
  }

  return (
    <div
      className="tm-setup-render-preview"
      role="group"
      aria-label={`${layout.name} interactive 3D preview`}
      data-render-coverage={coverage.state}
      data-render-model-key={coverage.identity.renderModelKey}
      data-render-layout-key={coverage.identity.renderLayoutKey}
    >
      <VehicleScene
        preset={coverage.preset}
        vehicle={vehicle}
        onHover={() => {}}
        onSelect={() => {}}
      />
      <span className="tm-setup-render-preview__hint">Drag to inspect</span>
    </div>
  );
};

SetupRenderPreview.propTypes = { layout: PropTypes.object.isRequired };

export default SetupRenderPreview;
